import { createFileRoute, notFound } from '@tanstack/react-router';

import ComplaintsPolicyPage from '@/pages/complaints-policy/ComplaintsPolicyPage';
import { getComplaintsPolicy } from '@/sanity/complaints-policy';
import { getHomeHeaderButton } from '@/sanity/landing-page';
import { getLegalLinks } from '@/sanity/legal-document';
import { complaintsPolicyPath } from '@/utils/complaints-policy';
import { buildPageMeta } from '@/utils/seo';

const complaintsPolicyTitle = 'Complaints policy — Budgy';
const complaintsPolicyDescription =
  'How to complain to Budgy, what happens next, and how long it takes.';

export const Route = createFileRoute('/complaints-policy')({
  loader: async () => {
    const [complaintsPolicy, headerButton, legalLinks] = await Promise.all([
      getComplaintsPolicy(),
      getHomeHeaderButton(),
      getLegalLinks(),
    ]);
    if (!complaintsPolicy) {
      throw notFound();
    }

    return { complaintsPolicy, headerButton, legalLinks };
  },
  component: ComplaintsPolicyPage,
  head: () =>
    buildPageMeta({
      title: complaintsPolicyTitle,
      description: complaintsPolicyDescription,
      path: complaintsPolicyPath,
    }),
});
